import React  from 'react'
import {
  SubFLex,
  MainHeading,
  SecondaryHeading,
  SecondGreyText,
} from '../style'
import { COLORS } from 'theme'
import moment from 'moment'

const CurrentlyPursuing = ({studentDetails,instituteName}) => {
  const currentDate = moment()
  return (
    <>
    {
    moment(parseInt(studentDetails?.currentCourse?.endedOn)).format('YYYY-MM-DD') > currentDate.format('YYYY-MM-DD') === true ?
      <MainHeading>Currently Pursuing</MainHeading>
      :
      ''
  }
      <SubFLex column gap="10px">
        <SecondaryHeading fontWeight="600">
          {studentDetails?.instituteCampusName}
        </SecondaryHeading>

        <SecondGreyText>
          {studentDetails?.currentCourse?.degree} in {studentDetails?.currentCourse?.department} {studentDetails?.currentCourse?.specialisation ? `(${studentDetails?.currentCourse?.specialisation})` : null}
         
        </SecondGreyText>
        <SubFLex gap="50px">
          <SecondGreyText color={COLORS.GREY_T_60}>
            Registration No.
          </SecondGreyText>
          <SecondGreyText>-</SecondGreyText>
          <SecondGreyText> {studentDetails?.uniRollNo}</SecondGreyText>
        </SubFLex>
      
      </SubFLex>
    </>
  )
}

export default CurrentlyPursuing
